<template>
    <div class="addAndModify">
        <el-container>
            <el-main ref="main" class="tabWrap">
                <el-tabs  v-model="activeName" style="width: 100%">
                    <el-tab-pane label="基本信息" name="Tab1" style="height: 700px;overflow-y: auto">
                        <el-form class="dataFormBox" :inline="true" :model="dataForm">
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label-width="120px" label="标题：">
                                        <el-input v-model="dataForm.title" placeholder="请输入标题" :readonly="true" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label-width="120px" label="来文字号：">
                                        <el-input v-model="dataForm.documentNum" placeholder="请输入发文字号" :readonly="true" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label-width="120px" label="来文单位：">
                                        <el-input v-model="dataForm.documentFromCompany" placeholder="请输入来文单位" :readonly="true" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label-width="120px" label="收文日期：">
                                        <el-date-picker
                                                v-model="dataForm.documentReceiveDate"
                                                :readonly="true"
                                                type="date"
                                                placeholder="请选择发文日期">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="16">
                                    <div class="sendList">
                                        <el-form-item
                                                label="部门："
                                                label-width="120px"
                                                ref="sendListRef"
                                        >
                                            <div class="el-input tag-wrapper">
                                                <el-tag
                                                        v-for="(tag, index) in dataForm.documentDeptJson"
                                                        :key="index"
                                                        style="margin-right: 5px;"
                                                >{{ tag.name }}</el-tag>
                                            </div>
                                        </el-form-item>
                                    </div>
                                </el-col>
                                <el-col :span="16">
                                    <el-form-item class="maxWidth" label-width="120px" label="拟办意见：">
                                        <el-input v-model="dataForm.comment" type="textarea" :rows="6" :readonly="true" placeholder="请输入拟办意见" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="附件" name="Tab2" style="height: 700px;overflow-y: auto">
                      <div>
                        <el-table :data="fileList" style="width: 100%; margin: 20px"
                                  size="mini" border>
                          <el-table-column type="index" width="50" label="序号"></el-table-column>
                          <el-table-column
                              v-for="(prop, index) in tableProps"
                              :key="index"
                              :prop="prop.prop"
                              :label="prop.label"
                              :min-width="prop.width"
                          ></el-table-column>
                          <el-table-column label="操作" width="150">
                            <template slot-scope="scope">
                              <el-button
                                  size="mini"
                                  @click="downloadFile(scope.$index, scope.row)"
                                  type="text"
                              >下载附件</el-button>
                              <el-button
                                  size="mini"
                                  @click="previewFile(scope.$index, scope.row,'document')"
                                  type="text"
                              >预览</el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="审批流程" name="Tab3" style="height: 700px;overflow-y: auto">
                        <div v-if="approveFlag === 'currentApprove'">
                            <approveItem
                                    :itemId="contractId"
                                    :approveType="approveType"
                                    :subapproveType="subapproveType"
                                    @finishApprove="close()"
                            >
                            </approveItem>
                        </div>
                        <div v-else>
                            <approveLine
                                    :itemId="contractId"
                                    :approveType="approveType"
                            ></approveLine>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </el-main>
            <el-footer class="containerBox">
                <div class="btnMid">
                    <el-button type="info" @click="close()">关 闭</el-button>
                </div>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
    import approveLine from "@/page/approveComponents/ApproveHistoryLine"; //历史审批流程
    import approveItem from "@/page/approveComponents/ApproveItem";
    import {
        getReceiveDetailService,
        setCheckExternalService,
    } from "@/services/documentServices";
import {previewFile} from "@/utils/index.js"
    import {
        exportExcelService2, //导出
        getTempUrlService //下载附件
    } from "@/services/allContractServices";
    import {goBackApprove} from '@/page/approveComponents/approve';
    export default {
        name: "detailAndApprove",
        data(){
            return {
                type: 1,
                activeName: 'Tab1',
                dataForm:{
                    id: '',
                    title: '',  // 标题
                    documentNum: '',  // 来文字号
                    documentFromCompany: '',  // 来文单位
                    documentReceiveDate: '',  // 收文日期
                    documentDeptJson: [],   //部门数据
                    documentDeptId: '', //部门id
                    comment: '',  // 拟办意见
                },
                fileList:[],
                tableProps: [
                    { prop: "name", label: "文件名称", width: "200px" },
                    { prop: "uploadUserName", label: "上传者", width: "140px" },
                    { prop: "uploadTime", label: "上传时间", width: "140px" },
                ],
                approveFlag: '', //审批状态
                approveType: "OFFICIAL_DOCUMENT_EXTERNAL", //审批类型
                subapproveType: '',
                contractId: 0,
            }
        },
        components: {
            approveLine, //审批历史流程
            approveItem, //审批
        },
        methods: {
            onActive(menuCode) {
                if(this.tabRouteParam.id){
                    this.dataForm.id = this.tabRouteParam.id;
                    this.approveFlag = this.tabRouteParam
                        ? this.tabRouteParam.approveFlag
                        : "";
                    this.contractId = Number(this.tabRouteParam.id);
                    this.getReceiveDetail();

                    this.type = this.tabRouteParam.type;
                    if(this.type == 2){
                      this.setCheckExternal();
                    }
                }
                this.documentType = this.tabRouteParam.documentType
            },
            //获取发文详情
            getReceiveDetail(){
                let paramsData = {
                    systemFileExternalId: this.dataForm.id
                }
                getReceiveDetailService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.dataForm = {
                            id: res.data.id,
                            title: res.data.title,  //标题
                            documentNum: res.data.documentNum,  // 来文字号
                            documentFromCompany: res.data.documentFromCompany,  // 来文单位
                            documentReceiveDate: res.data.documentReceiveDate,  // 收文日期
                            documentDeptJson: res.data.documentDeptId ? [{
                                deptId: res.data.documentDeptId,
                                name: res.data.documentDeptName
                            }]:[],   //部门数据
                            documentDeptId: res.data.documentDeptId, //部门id
                            comment: res.data.comment,  // 拟办意见
                        }
                        this.fileList = res.data.attachmentList;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            //设置查阅
            setCheckExternal(){
              let paramsData = {
                systemFileExternalId: this.dataForm.id
              }
              setCheckExternalService(paramsData).then( res => {
                if(res.code == 10000000){
                  this.dataForm = {
                    id: res.data.id,
                    title: res.data.title,  //标题
                    documentNum: res.data.documentNum,  // 来文字号
                    documentFromCompany: res.data.documentFromCompany,  // 来文单位
                    documentReceiveDate: res.data.documentReceiveDate,  // 收文日期
                    documentDeptJson: res.data.documentDeptId ? [{
                      deptId: res.data.documentDeptId,
                      name: res.data.documentDeptName
                    }]:[],   //部门数据
                    documentDeptId: res.data.documentDeptId, //部门id
                    comment: res.data.comment,  // 拟办意见
                  }
                  this.fileList = res.data.attachmentList;
                }else{
                  this.$message.error(res.msg);
                }
              }).catch(error => {
                this.$message.error("网络请求失败");
              });
            },
            //文件下载
            downloadFile(index, row) {
                let reqParam = {
                    filePath: row.attachmentItem
                };
                getTempUrlService(reqParam).then(
                    res => {
                        if (res.code == 10000000) {
                            //下载附件
                            const link = document.createElement('a');
                            // 这里是将链接地址url转成blob地址，
                            fetch(res.data).then(res => res.blob()).then(blob => {
                              link.href = URL.createObjectURL(blob)
                              // 下载文件的名称及文件类型后缀
                              link.download = row.name;
                              document.body.appendChild(link)
                              link.click()
                              //在资源下载完成后 清除 占用的缓存资源
                              window.URL.revokeObjectURL(link.href);
                              document.body.removeChild(link);
                            });
                            // exportExcelService2(res.data).then(res1 => {
                            //     this.$alert("下载成功", "提示", {
                            //         confirmButtonText: "确定"
                            //     });
                            // });
                        } else {
                            this.$alert(res.msg, "提示", {
                                confirmButtonText: "确定"
                            });
                        }
                    },
                    err => {
                        this.$alert("系统异常", "提示", {
                            confirmButtonText: "确定"
                        });
                    }
                );
            },
            //文件预览
            previewFile,
            // 关闭
            close(){
                if(this.approveFlag){
                    goBackApprove(this.approveFlag,'incomingManageDetails')
                }else{
                    this.bus.$emit("tabClose", "incomingManageDetails");
                    this.bus.$emit("navMenuChange", {
                        routeId: "incomingManage"
                    });
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .addAndModify {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
      .tabWrap {
        height: calc(100% - 60px);

        /deep/ .el-tabs--top {
          height: 100%;
          overflow: hidden;

          .el-tabs__content {
            height: calc(100% - 140px);
            padding: 0 20px 20px;
            overflow: auto;

            .el-form-item {
              width: 100%;
            }

            .el-checkbox {
              line-height: 40px;
            }

            .el-textarea {
              min-width: 0px !important;
            }
            .el-cascader {
              width: 100%;
            }

            .el-form-item__content {
              width: calc(100% - 150px);

              .el-input {
                width: 100%;
              }
            }
          }
        }
      }
    }
    .sendList {
        /deep/.el-form-item{
            width: 100%;
            display: flex;
            .el-form-item__content {
                width: 78%;
                display: flex;
                .el-input {
                    flex: 1;
                }
                .el-button {
                    margin-left: 10px;
                    height: fit-content;
                }
            }
        }

        .tag-wrapper {
            border: 1px solid #dcdfe6;
            padding: 0 5px;
        }
    }
    .containerBox {
      width: 100%;
      height: 36px !important;
      position: fixed;
      bottom: 44px;
      left: 0;
      text-align: start;
    }
    .btnMid {
      position: relative;
      left: 27%;
      bottom: 0px;
      display: flex;
    }
    /deep/.ApproveItem .bottomBtn{
      bottom: 44px;
      z-index: 10;
    }
</style>
